import { setCookie } from './setCookie';
/**
 * This represents an array of names that need to be deleted.
 * @param names
 */

export function deleteCookies(names: string[]) {
  names.map(name => setCookie(name, '', 0));
}
